// extracted by mini-css-extract-plugin
export var addButton = "_ef-0";
export var border = "_ef-8";
export var check = "_ef-h";
export var danger = "_ef-6";
export var dropdownContainer = "_ef-1";
export var editModalBody = "_ef-j";
export var footerContainer = "_ef-i";
export var fullWidth = "_ef-a";
export var hide = "_ef-9";
export var icon = "_ef-3";
export var input = "_ef-7";
export var inputFlex = "_ef-b";
export var inputWrapper = "_ef-c";
export var manualFocus = "_ef-5";
export var optionButton = "_ef-4";
export var pillWrapper = "_ef-e";
export var pointer = "_ef-2";
export var showOverflow = "_ef-f";
export var tagsFlex = "_ef-d";
export var xButton = "_ef-g";